/**
 *              DATAGRID
 * */
export function customizeDataGrid(grid, translations) {
    if (typeof grid === "undefined" || typeof translate === "undefined")
        return;

    grid.beginUpdate();

    var columns = grid.option("columns");
    for (var i = 0; i < columns.length; i++) {
        var column = columns[i];
        if (typeof column.dataField === "undefined")
            continue;
        if (typeof column.dataField === "string" && column.dataField.trim() == '')
            continue;

        if (typeof translations[column.dataField] !== "undefined") {
            grid.columnOption(i, "dataType", translations[column.dataField].dataType);
            column.dataType = translations[column.dataField].dataType;

            if (typeof translations[column.dataField].format !== "undefined")
                grid.columnOption(i, "format", formatGet(column, translations));
        }
        else {
            if (!column.dataType)
                throw "Column defined in grid without dataType: " + column.dataField;
        }

        var caption = grid.columnOption(i, "caption");
        if (caption[0] === "$")
            caption = caption.substring(1, caption.length);
        else if (caption.endsWith("-long"))
            caption = translateLong(translations, column.dataField)
        else
            caption = translate(translations, column.dataField);
        grid.columnOption(i, "caption", caption);
    }

    grid.endUpdate();
}

export function translate(translations, field) {
    if (typeof translations[field] !== "undefined")
        return translations[field].tr;
    return field;
}

export function translateLong(translations, field) {
    if (typeof translations[field] !== "undefined")
        return translations[field].trL;
    return field;
}

/**
 *              FORM
 * */
export function customizeFormItems(items, form, translation, validationCallback) {
    _customizeFormItems(items, "items", form, translation, validationCallback);
}

function _customizeFormItems(items, path, form, translation, validationCallback) {
    for (var i = 0; i < items.length; i++) {
        var _path = `${path}[${i}]`;

        if (items[i].items || items[i].tabs)
            _customizeFormItems(items[i].items || items[i].tabs, `${_path}.${(items[i].items ? 'items' : 'tabs')}`, form, translation, validationCallback);
        else
            customizeFormItem(items[i], _path, form, translation, validationCallback);
    }
}

export function formatGet(item, translation) {


    var dataField = item.dataField;
    if (dataField == null) {
        if (typeof item === 'string' || item instanceof String)
            dataField = item;
        else
            throw "formatGet called with wrong item parameter";
    }

    if (typeof dataField !== 'string' && !(dataField instanceof String))
        throw "formatGet could not resolve dataField name as string";

    if (window.___GOP.CultureInfo == null)
        return translation[dataField].format;
    else {
        var tr = translation[dataField]["format_" + window.___GOP.CultureInfo];
        if (tr != null) {
            return tr;
        }
        else
            return translation[dataField].format;
    }
}


export function customizeFormItem(item, itemPath, form, translation, validationCallback) {
    if (item.itemType !== "simple" ||
        item.dataField === null ||
        typeof translation === "undefined" ||
        typeof (translation[item.dataField]) === "undefined")
        return;

    item.editorOptions = item.editorOptions || {};
    item.editorOptions.associatedDataField = item.dataField;

    if (typeof item.label === "undefined")
        item.label = { text: translation[item.dataField].tr };

    if (item.editorType === "dxTextArea" || item.editorType === "dxTextBox" || (item.itemType === "simple" && item.editorType === undefined)) {
        item.editorOptions.onValueChanged = OnValueChanged;
    }

    if (typeof translation[item.dataField].format !== "undefined") {
        if (item.editorType === "dxDateBox") {
            item.editorOptions.displayFormat = formatGet(item, translation);

            if (!item.editorOptions.calendarOptions)
                item.editorOptions.calendarOptions = {};
            item.editorOptions.calendarOptions.showWeekNumbers = true;
        }
        else if (item.editorType === "dxNumberBox") {
            item.editorOptions.format = formatGet(item, translation);
            item.editorOptions.showClearButton = true;
        }
    }

    if (validationCallback == null) {
        validationCallback = function (e) {
            if (e.formItem.isRequired === true) {
                return HasValue(e.value);
            }
            return true;
        }
    }

    item.validationRules = item.validationRules || [];
    item.validationRules.push({ type: "custom", xcOptions: { type: 'required', dataField: item.dataField }, validationCallback: validationCallback, reevaluate: true, message: translation[item.dataField].tr + " is required" });


    if (translation[item.dataField].dataType == 'string' &&
        translation[item.dataField].maxLength) {
        item.validationRules.push({ type: "stringLength", max: translation[item.dataField].maxLength, message: "The length of the value is too long - max:" + translation[item.dataField].maxLength });
        var x = 1;
    }



    alterRequiredRuleFormItem(item, itemPath, form, translation);
}



function OnValueChanged(e) {
    if (e.value === '')
        e.component.option('value', null);
}

export function AddDefaultRequiredValidationRule(e, validationCallback) {

    if (validationCallback == null) {
        validationCallback = function (e) {
            return HasValue(e.value);
        }
    }

    var validationRules = e.component.option("validationRules") || [];
    validationRules.push({ type: "custom", xcOptions: { type: 'required' }, validationCallback: validationCallback, reevaluate: true, message: "required" });
    e.component.option("validationRules", validationRules);
}

function HasValue(val) {
    if (val === undefined ||
        val === null ||
        val === '')
        return false;
    return true;

}

export function alterRequiredRuleFormItem(item, itemPath, form, translation, required) {

    //var ruleExists = false;
    //var rulesChanged = false;

    if (!item || !item.dataField)
        return;

    var isRequired = required || translation[item.dataField].required; //|| item.isRequired removed

    if (translation[item.dataField].dataType != 'boolean')
        form.option(`${itemPath}.isRequired`, isRequired); //if used like this: item.isRequired = isRequired; UI will not get updated !!!!

    //var validationRules = item.validationRules || [];
    //for (var i = 0; i < validationRules.length; i++) {
    //    if (validationRules[i].xcOptions && validationRules[i].xcOptions.type == 'required') {
    //        validationRules[i].xcOptions.isRequired = isRequired;
    //    }
    //}
    //    if (isRequired) {
    //        ruleExists = true;
    //        break;
    //    }

    //    validationRules.splice(i--, 1);
    //    rulesChanged = true;
    //}

    //if (!ruleExists && isRequired) {
    //    validationRules.push({ type: "stringLength", min: 1, message: translation[dataField].tr + " is required" });
    //    rulesChanged = true;
    //}

    //if (rulesChanged)
    //    form.option(`${itemPath}.validationRules`, validationRules);
}

export function updateLinkedTable(drs, foreignKeyName, selectedForeignIds, addRowFunc) {
    for (var i = drs.length - 1; i >= 0; i--) {
        var id = drs[i][foreignKeyName];
        if (!selectedForeignIds.includes(id))
            drs.splice(i, 1);
    }

    selectedForeignIds.forEach(id => {
        var existingRow = drs.find(x => x[foreignKeyName] == id)
        if (existingRow == undefined)
            drs.push(addRowFunc(id));
    });
}

import { createLookupDataSource, addIsActiveCondition } from ".";

export function createSimpleLookupOptions(valueExpr, displayExpr, repository, sortBy, isActiveField) {
    return {
        dataSource: createLookupDataSource(valueExpr, repository, sortBy ? sortBy : displayExpr, null, isActiveField ? (loadOptions) => addIsActiveCondition(loadOptions, isActiveField) : null),
        valueExpr,
        displayExpr,
        dropDownOptions: {
            closeOnOutsideClick: true
        }
    }
}

export function bloParseDateFields(blo, translations) {
    Object.keys(blo).forEach(key => {
        if (Array.isArray(blo[key])) {
            blo[key].forEach(item => bloParseDateFields(item, translations))
            return;
        }

        var translation = getTranslation(key, translations)
        if (blo[key] && translation && (translation.dataType == "date" || translation.dataType == "datetime"))
            blo[key] = new Date(blo[key])
    });
}

function getTranslation(field, translations) {
    translations = translations || [];
    if (!Array.isArray(translations))
        translations = [translations];

    for (var i = 0; i < translations.length; i++)
        if (translations[i][field])
            return translations[i][field]
    return void 0
}

export function setupDateBoxMinDate(e, min) {
    if (e.name != "opened")
        return;

    if (!e.value && e.component.option("min"))
        e.component.option("min", void 0)
    else if (e.value && e.component.option("min") == undefined)
        e.component.option("min", min || new Date())
}

export function getElHePathFromLocation() {

    if (window.location.href.indexOf('?') > -1) {
        var elHePath = window.location.href.substring(window.location.origin.length).substring(0, window.location.href.substring(window.location.origin.length).indexOf('?'));
        elHePath = elHePath.replace('/#/', '');
        return elHePath;
    }
    else
        return null;

}